/**
 * Toast helper — wraps sonner with explicit aria semantics.
 *
 * Sonner's error variant already applies role="alert" + aria-live="assertive" by default,
 * but we re-export through this helper so we can centralize behavior + safe-message extraction.
 */
import { toast as sonner } from "sonner";

const extractMessage = (msg, fallback = "Something went wrong") => {
  if (msg == null) return fallback;
  if (typeof msg === "string") return msg;
  if (typeof msg === "object") {
    if (msg.message) return String(msg.message);
    try {
      return JSON.stringify(msg);
    } catch {
      return fallback;
    }
  }
  return String(msg);
};

export const toast = {
  ...sonner,
  success: (msg, opts) => sonner.success(extractMessage(msg, "Done"), opts),
  info: (msg, opts) => sonner.info(extractMessage(msg, ""), opts),
  // Errors get assertive announcement via sonner's built-in role="alert" + aria-live="assertive"
  error: (msg, opts) => sonner.error(extractMessage(msg, "Something went wrong"), opts),
};

export default toast;
